/* eslint-disable indent */
/* eslint-disable curly */
/* eslint-disable no-void */
/* eslint-disable no-extend-native */
/* eslint-disable no-implicit-coercion */
import Promise from 'promise-polyfill';
// eslint-disable-next-line import/no-unassigned-import
import 'formdata-polyfill';

function initializePolyfills() {
	// We take them from MDN, https://developer.mozilla.org
	// To add to window
	if (!window.Promise) {
		window.Promise = Promise;
	}
	// classlist on svg
	// https://stackoverflow.com/a/8098430

	if (!Object.getOwnPropertyDescriptor(Element.prototype, 'classList') && HTMLElement && Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'classList')) {
			Object.defineProperty(Element.prototype, 'classList', Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'classList'));
		}

	if (window.NodeList && !NodeList.prototype.forEach) {
		NodeList.prototype.forEach = function (callback, thisArgument) {
			thisArgument = thisArgument || window;
			for (let index = 0; index < this.length; index++) {
				callback.call(thisArgument, this[index], index, this);
			}
		};
	}

	// includes polyfill (string)

	if (!String.prototype.includes) {
		String.prototype.includes = function (search, start) {
			if (typeof start !== 'number') {
				start = 0;
			}

			if (start + search.length > this.length) {
				return false;
			}
			return this.includes(search, start);
		};
	}

	if (!Element.prototype.toggleAttribute) {
		Element.prototype.toggleAttribute = function (name, force) {
			if (force !== void 0) force = !!force;

			if (this.hasAttribute(name)) {
				if (force) return true;

				this.removeAttribute(name);
				return false;
			}

			if (force === false) return false;

			this.setAttribute(name, '');

			return true;
		};
	}

	if (!Element.prototype.matches) {
		Element.prototype.matches =
			Element.prototype.msMatchesSelector ||
			Element.prototype.webkitMatchesSelector;
	}

	if (!Element.prototype.closest) {
		Element.prototype.closest = function (s) {
			if (Element.prototype.matches.call(this, s)) {
				return this;
			}
			let element = this.parentElement || this.parentNode;
			while (element !== null && element.nodeType === 1) {
				if (Element.prototype.matches.call(element, s))
					return element;
				element = element.parentElement || element.parentNode;
			}
		};
	}

	if (!String.prototype.endsWith) {
		String.prototype.endsWith = function (search, thisLength) {
			if (thisLength === undefined || thisLength > this.length) {
				thisLength = this.length;
			}
			return this.slice(thisLength - search.length, thisLength) === search;
		};
	}
}

export default {initializePolyfills};
